import api from "../../utils/api/api.utils";
import { mapObjectWithTimeZonedDatesToUtcIsoString } from "../../utils/date.utils";
import { GENERATOR_PARAMS } from "./externalAction.constants";
export var performExternalAction = function (_a) {
    var id = _a.id, key = _a.key, data = _a.data, token = _a.token;
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(id, "/").concat(key), {
        isV2: true,
        data: mapObjectWithTimeZonedDatesToUtcIsoString(data, false),
        isExternalActionUrl: true,
        headers: {
            Authorization: "Bearer ".concat(token),
        },
    });
};
